// Fix : EA Sticky Add to Cart 
// Branche l'appel du bouton "Ajouter au panier" sticky vers le vrai bouton géré par le thème

// Utilisation de la délégation d'événement sur document en mode CAPTURE (true)
// Cela permet d'intercepter le clic AVANT que le script de l'app (tiers) ne s'exécute sur le bouton.
document.addEventListener('click', (e) => {
    // On cherche si le clic provient du bouton sticky (ou d'un de ses enfants)
    // On cherche si le clic provient du bouton sticky (ou d'un de ses enfants)
    const eascStickyButton = e.target.closest('.ea-sticky-cart .eascStickyAddToCartBar .eascStickyAddToCartBtnDiv button');

    if (!eascStickyButton) return;

    // ARRÊT TOTAL DE L'APPLICATION "STICKY CART"
    e.preventDefault();
    e.stopPropagation(); 
    e.stopImmediatePropagation(); // Sécurité supplémentaire

    // Cible le vrai bouton "Ajouter au panier" du thème (géré par product-form.js)
    const themeSubmitBtn = document.querySelector('add-to-cart-component button[name="add"]');

    if (themeSubmitBtn) {
        // Simule un clic sur le bouton natif pour déclencher la logique du thème (AJAX, Tiroir, etc.)
        themeSubmitBtn.click();
    } else {
        console.warn("[LDS] Bouton d'ajout au panier natif non trouvé. Fallback vers submit form.");
        const productForm = document.querySelector('product-form-component form, form[action*="/cart/add"]');
        if (productForm) productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    
}, true); // <--- Le 'true' ici force l'écoute en phase de capture (avant les events de l'élément)


function updateScrollbarWidth() {
    const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${scrollbarWidth}px`
    );
}


(function () {

    /*
     * Fonction qui permet de calculer et de renseigner la largeur de la scrobar du navigatreur
     * Utile pour éviter les sauts de mise en page lors de l'ouverture de modales ou de menus   en overflow hidden
     */
    function updateScrollbarWidth() {
        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        document.documentElement.style.setProperty(
            '--scrollbar-width',
            `${scrollbarWidth}px`
        );
    }

    /**
     * Expose les fonctions globalement
     * (utile si déclenché depuis HTML ou autre script)
     */
    window.LDS = {
        updateScrollbarWidth,
    };

    /**
     * Initialisation
     */
    document.addEventListener('DOMContentLoaded', function () {
        updateScrollbarWidth();
    });

    /**
     * Recalcul en cas de resize
     */
    window.addEventListener('resize', function () {
        updateScrollbarWidth();
    });

    /**
     * Gestion des liens offusqués (SEO)
     */
    document.addEventListener('click', (e) => {
        const obfLink = e.target.closest('[data-uri]');
        if (obfLink) {
          const encodedUrl = obfLink.getAttribute('data-uri');
          if (encodedUrl) {
             try {
                 const url = atob(encodedUrl);
                 window.location.href = url;
             } catch(err) {
                 console.error('Failed to decode URL', err);
             }
          }
        }
    });
})();